// extracted by mini-css-extract-plugin
export default {"modal__ingredient_details":"modal-switch_modal__ingredient_details__wo4AL","modal__feed_order":"modal-switch_modal__feed_order__kgUnE"};